import { useEffect, useRef, useState } from "react";
import RightModal from "../../../components/Modal/RightModal";
import SavedFilterComponent from "../../../components/SavedFilters/SavedFilterComponent";
import { initialUnderContractFilterData } from "../../../utils/initialData";
import { countNonMatchingEntries, handleDropdownClose } from "../../../utils/utils";
import ExecutedFilterData from "../../Executed LOI/component/ExecutedFilterData";



const UnderContractArchieveFilter = ({ filterData, onSetFilterData, onCallApiAgain, from }) => {
  const dropdownRef = useRef(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [selectedSavefilterId, setSelectedSaveFilterId] = useState(() => {
    const id = localStorage.getItem("underContractArchiveSelectedSavefilterId");
    return id ? id : "";
  });

  const count = countNonMatchingEntries(filterData, initialUnderContractFilterData);

  useEffect(() => {
    const handleClose = () => {
      setIsSidebarOpen(false);
    };
    handleDropdownClose(dropdownRef, handleClose);
  }, []);

  const handleFilter = () => {
    localStorage.setItem("underContractArchiveFilterData", JSON.stringify(filterData));
    onCallApiAgain();
    setIsSidebarOpen(false);
    setSelectedSaveFilterId("");
  };

  const handleFilterChange = (value, name) => {
    onSetFilterData({ ...filterData, [name]: value });
  };

  const handleSelectFilter = (value) => {
    const dataToSet = {
      count: value?.count ?? "",
      broker: value?.broker,
      start_count: value?.start_count ?? "",
      end_count: value?.end_count ?? "",
      fell_count: value?.fell_count ?? "",
      fell_start_count: value?.fell_start_count ?? "",
      fell_end_count: value?.fell_end_count ?? "",

    };
    localStorage.setItem("underContractArchiveFilterData", JSON.stringify(dataToSet));
    onSetFilterData(dataToSet);
    onCallApiAgain(dataToSet);
  };

  const saveSearchFilterData = {
    count: filterData?.count ?? "",
    broker: filterData?.broker,
    start_count: filterData?.start_count ?? "",
    end_count: filterData?.end_count ?? "",
    fell_count: filterData?.fell_count ?? "",
    fell_start_count: filterData?.fell_start_count ?? "",
    fell_end_count: filterData?.fell_end_count ?? "",

  };

  return (
    <div>
      <SavedFilterComponent
        filterKey="underContractArchiveFilterData"
        selectedFilterIdKey="underContractArchiveSelectedSavefilterId"
        from="Under Contract Archieves Save Filter"
        count={count}
        isSidebarOpen={isSidebarOpen}
        saveSearchFilterData={saveSearchFilterData}
        selectedSavefilterId={selectedSavefilterId}
        initialFilterData={initialUnderContractFilterData}
        onCallApiAgain={onCallApiAgain}
        onSetFilterData={onSetFilterData}
        onSetSelectedSaveFilterId={(value) => {
          setSelectedSaveFilterId(value);
        }}
        handleSelectFilter={handleSelectFilter}
        onSetIsSidebarOpen={(value) => setIsSidebarOpen(value)}
      />

      <RightModal
        isOpen={isSidebarOpen}
        onClose={() => {
          setIsSidebarOpen(false);
          onSetFilterData(initialUnderContractFilterData);
        }}
        ref={dropdownRef}
        title={"Filter"}
        from={from}
        desc={`Enter ${from} information.`}
        onFilter={handleFilter}
        saveSearchFilterData={saveSearchFilterData}
        onSetSelectedSaveFilterId={(value) => setSelectedSaveFilterId(value)}
      >
        <ExecutedFilterData isSidebarOpen={isSidebarOpen} filterData={filterData} handleFilterChange={handleFilterChange} onSetFilterData={onSetFilterData} from="undercontractarchieve" />
      </RightModal>
    </div>
  );
};

export default UnderContractArchieveFilter;
